var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCourseComplete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(3 3)",
    fill: "#5B788F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(15.119 17.9)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 5.563,
    y2: 5.563,
    transform: "translate(0 4.636)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 10.199,
    y2: 10.199,
    transform: "translate(5.563)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseComplete);
export default __webpack_public_path__ + "static/media/icon_course_complete.e3bf8591272ab9a80aad1179b50b883a.svg";
export { ForwardRef as ReactComponent };